import React, { FunctionComponent } from "react"
import AsyncSelectInput from "../../../components/Form/Select/AsyncSelect"
import { iResponse, iSelectOptionType } from "../../../definitions/interfaces"
import { get } from "../../../store/data/actions"

const ProfileSettings: FunctionComponent = () => {
  const loadCompanyProfiles = async () => {
    const result = await get<iResponse<iSelectOptionType<string>[]>>({
      link: "/v1/users-companies-list",
    })

    return result.data
  }

  return (
    <div className="scrollable container">
      <AsyncSelectInput
        name="selectedProfile"
        loadOptions={loadCompanyProfiles}
        defaultOptions
        label="Selected business profile"
      />
    </div>
  )
}

export default ProfileSettings
